module.exports = __webpack_public_path__ + "media/images/story/top/point_image_1-1806cb1faa8f10845435346e42c55ea1.jpg";